import React from "react";
import R14, { Redirect, AsyncStorage, Platform, AsyncSessionStorage } from "./core";
import LoginScreen from "./screens/LoginScreen";
import DashboardScreen from "./screens/DashboardScreen";
import BillDetailsScreen from "./screens/BillDetailsScreen";
import ProfileViewScreen from "./screens/ProfileViewScreen";
import MessageScreen from "./screens/MessageScreen";
import MakePaymentScreen from "./screens/MakePaymentScreen";
import BillHistoryScreen from "./screens/BillHistoryScreen";
import PaymentScreen from "./screens/PaymentScreen";
import DeclineComponent from "./components/DeclineComponent";
import ExtensionScreen from "./screens/ExtensionScreen";
import BillersDirectoryScreen from "./screens/BillersDirectoryScreen";
import PamMessageScreen from "./screens/PamMessageScreen";
import SimpleMessageScreen from "./screens/SimpleMessageScreen";
import DeleteAccountScreen from "./screens/DeleteAccountScreen";
import CreatingMessageScreen from "./screens/CreatingMessageScreen";
import SimpleMessageDetailScreen from "./screens/SimpleMessageDetailScreen";
import BillReceiptScreen from "./screens/BillReceiptScreen";
import PaymentOptionsScreen from "./screens/PaymentOptionsScreen";
import NotificationScreen from "./screens/NotificationScreen";
import BillRequestScreen from "./screens/BillRequestScreen";
import BulkPaymentScreen from "./screens/BulkPaymentScreen";
import TextToPayScreen from "./screens/TextToPayScreen";
import MyBanksScreen from "./screens/MyBanksScreen";
import LinkPayerScreen from "./screens/LinkPayerScreen";

import CommonUtility from "./utils/CommonUtility";
import UserAgentValidator from "./utils/UserAgentValidator";
import LayoutComponent from "./components/LayoutComponent";

// PCH Screens
import PCHPrivacyPolicy from "./screens/PCH/PCHPrivacyPolicy";
import PCHUserTerms from "./screens/PCH/PCHUserTermsScreen";
import AccessServicesAgreement from "./screens/PCH/AccessServicesAgreementScreen";
import TermsAndConditionsScreen from "./screens/PCH/TermsAndConditionsScreen";
import CheckoutSessionComponent from "./components/payments/CheckoutSessionComponent";

import { NATIVE_APP_URL } from "./constant/app.constant";
import { CommonString } from "./constant/appCommonText";
import { analyticsLogs } from "./utils/AnalyticLogs";
import RSAencryption from "./utils/RSAencryption";

export default class Actions extends R14.Actions {
  async shouldActionLoad({ to, from, app }) {
    let userLoginDetail = await this.dm.rest.getUser();
    let ret = true;
    if (from === null && Platform.OS === 'web') {
      app.ui.snackBar.hide().show({
        message: " Pay UK",
        variant: "success",
        dismissTimeout: 0.001,
      });
    }

    /** Start - Mix Panel tracking event */
    analyticsLogs(CommonString.PAGE_NAVIGATION, null, userLoginDetail,
      (from && from._path ? `${NATIVE_APP_URL + from._path}` : null),
      (to && to._path ? `${NATIVE_APP_URL + to._path}` : null));
    /** End - Mix Panel tracking event */

    // await app.dm.userSession.init();
    if (!to.metadata.public) {
       ret = <Redirect to="login" />;

      if (app.dm.userSession.isLoggedIn) {
        // search screen reset
        let isAlreadyOpen = !!from && !!["dashboard", "makePaymentRoutes", "simpleMessageRoute", "billersDirectoryRoute"].includes(from._name) ? app.dm.userSearchDomain.state.isSearchOpen : app.dm.userSearchDomain.state.isAlreadyOpen;
        app.dm.userSearchDomain.setState({
          isAlreadyOpen: isAlreadyOpen,
          isSearchOpen: false,
          currentOpenScreen: from,
        });

        if (!!app.dm.userSearchDomain.state.isAlreadyOpen && !!from && !!to) {
          if ((!!["payTypeRoute", "payPartialRoute", "declinedRoute", "extensionRoute", "billReceiptRoute", "billDetailsRoute"].includes(from._name) && ["makePaymentRoutes", "dashboard"].includes(to._name))
            || (["simpleMessageDetailRoute"].includes(from._name) && ["simpleMessageRoute"].includes(to._name))
            || (["pamMessageRoute"].includes(from._name) && ["billersDirectoryRoute"].includes(to._name))) {
            let oldRoute = await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_HOMESCREEN);
            app.dm.userSearchDomain.setState({
              isSearchOpen: oldRoute === to._name ? app.dm.userSearchDomain.state.isAlreadyOpen : false,
            });
          }
        }
        ret = true;
      }
    }
    if (!!from && !!["simpleMessageRoute", "billersDirectoryRoute"].includes(from._name))
      app.dm.notificationDomain.setState({
        notificationThreadIds: [],
      });

    app.dm.dashboard.setState({
      oldRoute: from ? from._name : "dashboard",
    });
    app.dm.notificationDomain.setState({
      isMobileDevice: UserAgentValidator.isMobileDevice(),
    });
    return ret;
  }

  async login() {
    let username = (await AsyncStorage.getItem("username")) || "";
    return <LayoutComponent hideHeader={true} isAuthenticated={false} hideCopyright={true} children={<LoginScreen bEnforcePasswordChange={false} username={username} />} />
  }

  async logout() {
    const user = await this.dm.rest.getUser();
    if (!user) {
      let navRoute = await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_HOMESCREEN);
      this.nav.to(!!navRoute ? navRoute : "login");
    }
    else
      this.dm.userSession.setState({
        isLoggedOut: true,
        sessionInActive: false
      });
    return <LayoutComponent hideHeader={true} isAuthenticated={true} hideCopyright={false} />
  }

  async landing() {
    return <Redirect to={"login"} />
  }

  async dashboard() {
    this.dm.userSession.setState({isLoading : true});

    const userLoginDetail = await this.dm.rest.getUser();
    if (userLoginDetail !== null) {
      this.dm.dashboard.setState({
        selectedBlock: [],
        isBlockNavigation: false
      })
      await this.dm.rest.getBillers();

      this.dm.userSession.setState({isLoading : false});

      return <LayoutComponent hideHeader={true} children={<DashboardScreen userLoginDetail={userLoginDetail} />} />
    }
    else {
      this.nav.to("login");
    }
  }

  async makePaymentAction() {
    let billers = [];
    this.dm.userSession.setState({isLoading : true});
    const buBillerDetail = await this.dm.rest.getBillerBUs();
    if (buBillerDetail && buBillerDetail.billNameList && buBillerDetail.billNameList.length > 0) billers = buBillerDetail.billNameList;
    this.dm.userSession.setState({isLoading : false});
    return <LayoutComponent hideHeader={true} children={<MakePaymentScreen billers={billers} />} />
  }

  async bulkPaymentAction() {
    let userLoginDetail = await this.dm.rest.getUserWithDetails();
    return <LayoutComponent hideHeader={true} children={ <BulkPaymentScreen userDetail={userLoginDetail} /> } />
  }

  async pamMessageAction({ pamId, pid }) {
    try {
      this.dm.userSession.setState({isLoading : true});
      let pamM = await this.dm.billerDirectoryDomain.getPamMessagesByPamId(pamId);
      let pamA = await this.dm.billerDirectoryDomain.moreInfoMessages(pamId, pid);
      let userDetails = null;
      if (!pamA) {
        this.dm.userSession.setState({isLoading : false});
        this.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
        return false;
      }
      let list = await this.dm.rest.getBillers();
      let flag = true;
      let biller = list.find((elm) => elm.uid === pamM[0].billerUid);
      if (!!biller) {
        flag = 'messagingToggleValue' in biller ? biller.messagingToggleValue : true;
        pamM[0].biller = biller;
        userDetails = await this.dm.rest.getuserBUDetails(biller)
      }

      if (!!pamM && pamM.length > 0 && !!pamA && pamA.textToPayPreferences)
        pamM[0].textToPayPreference = pamA.textToPayPreferences;
      this.dm.userSession.setState({isLoading : false});

      return <LayoutComponent hideHeader={false} disableScroll={true} children={ <PamMessageScreen pam={pamM[0]} moreInfo={pamA} userDetails={userDetails} messageFlag={flag} /> } />

    } catch (error) {
      this.dm.userSession.setState({isLoading : false});
      this.nav.back();
    }
  }

  async billDetailsAction() {
    let threadId = "";
    let { billDetails } = this.dm.billDetails.state;
    if (!!billDetails && !!billDetails.threadId) {
      threadId = billDetails.threadId;
    }
    else {
      this.nav.to(await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_HOMESCREEN));
      return false;
    }
    this.dm.userSession.setState({ isLoading: true });
    let userDetails = await this.dm.rest.getUserWithDetails();
    if (!!userDetails) {
      let data = await this.dm.dashboard.getBill(threadId);
      if (!data || !data.message) {
        this.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
        return false;
      }

      const messages = data.message;
      let messageFlag = !!data.billDetail.biller ? data.billDetail.biller.messagingToggleValue : true;
      if (!!!data.billDetail.biller) {
        this.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
        this.nav.to("dashboard")
        return false;
      }

      let userMoreInfo = await this.dm.rest.getuserBUDetails({
        buId: messages.messages[0].envelope.messageHeader.buId,
        billerRef: messages.messages[0].envelope.messageHeader.senderPIDRef,
        payerRef: messages.messages[0].envelope.messageHeader.recipientPIDRef,
        payerId: messages.messages[0].envelope.messageHeader.recipientPid
      })
      let linkPids = await this.dm.rest.getLinkedPID();
      userDetails = { ...userDetails, ...userMoreInfo };
      userDetails.linkPids = linkPids.split(',');
      this.dm.userSession.setState({ isLoading: false });
      return <LayoutComponent hideHeader={true} children={ <BillDetailsScreen billDetails={data.billDetail} messages={messages} userDetails={userDetails} messageFlag={messageFlag} billerDetails={data.billDetail.biller} /> } />

    }
    else {
      this.dm.userSession.setState({ isLoading: false });
      this.nav.to("login");
    }
  }

  async profileViewAction() {
    this.dm.userSession.setState({isLoading : true});
    const userLoginDetail = await this.dm.rest.getUser();
    const userBUDetails = await this.dm.rest.getuserBUDetails();
    const currencyFormatterList = await this.dm.miscellaneousDomain.getMstCurrencyFormatter();
    if (!!currencyFormatterList && currencyFormatterList.length > 0) {
      if (userLoginDetail.currencyFormat && userLoginDetail.currencyFormat.value)
        userLoginDetail.currencyFormat = currencyFormatterList.find(e => e.value === userLoginDetail.currencyFormat.value);
      else userLoginDetail.currencyFormat = currencyFormatterList.find(e => e.isPrimary);
    }
    this.dm.userSession.setState({isLoading : false});
    return <LayoutComponent hideHeader={Platform.OS === 'web' ? false : true} children={<ProfileViewScreen profile={userLoginDetail} profileActionType={"view"} userBUDetails={userBUDetails} currencyFormatterList={currencyFormatterList} />} />

  }

  async messageScreenAction() {
    this.dm.userSession.setState({ isLoading: true });
    let threadId = "";
    let { billDetails } = this.dm.billDetails.state;
    if (!!billDetails && !!billDetails.threadId) {
      threadId = billDetails.threadId;
    }
    else {
      this.nav.to(await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_HOMESCREEN));
      return false;
    }

    let data = await this.dm.dashboard.getBill(threadId);
    if (!data || !data.message) {
      this.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
      return false;
    }
    const bd = data.message;
    let list = await this.dm.rest.getBillers();
    let userDetails = await this.dm.rest.getUser();
    let userMoreInfo = await this.dm.rest.getuserBUDetails({
      buId: bd.messages[0].envelope.messageHeader.buId,
      billerRef: bd.messages[0].envelope.messageHeader.senderPIDRef,
      payerRef: bd.messages[0].envelope.messageHeader.recipientPIDRef,
      payerId: bd.messages[0].envelope.messageHeader.recipientPid
    })
    let linkPids = await this.dm.rest.getLinkedPID();
    userDetails = { ...userDetails, ...userMoreInfo };
    userDetails.linkPids = linkPids.split(',');
    this.dm.userSession.setState({ isLoading: false });
    return <LayoutComponent hideHeader={false} children={ <MessageScreen displayMessages={bd.messages} billDetails={data.billDetail} billerList={list} userDetails={userDetails} /> } />

  }

  async billHistoryScreenAction() {
    let { billDetails } = this.dm.billDetails.state;
    if (!!billDetails && !!billDetails.uid) {
      this.dm.userSession.setState({isLoading : true});
      let messagesList =  await this.dm.dashboard.getBillHistory({
        filter: {
          paymentStatus: { in: ['Paid', 'Declined'] },
          ...(!!billDetails && billDetails.billerUid ? {billerUid: { eq: billDetails.billerUid }} : {}),
        }
      });

      messagesList = messagesList.nodes;

      const messages = CommonUtility.displayHistoryBills(messagesList, billDetails);
      this.dm.userSession.setState({ isLoading: false });
      return <LayoutComponent hideHeader={false} children={  <BillHistoryScreen billDetails={billDetails} messages={messages} /> } />
    }
    else {
      this.nav.back();
    }
  }

  async payTypeAction({ paytype }) {
    let { billDetails } = this.dm.billDetails.state;
    if (!!billDetails && !!billDetails.threadId) {
      this.dm.userSession.setState({ isLoading: true });
      let user = await this.dm.rest.getUserWithDetails();
      let data = await this.dm.dashboard.getBill(billDetails.threadId);
     if (!data || !data.message) {
      this.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
        return false;
      }
      let billData = data.billDetail;
      let senderName = await this.dm.billDetails.getSenderName({
        buId: billData.messageHeader.buId,
        billerRef: billData.messageHeader.senderPIDRef,
        payerRef: billData.messageHeader.recipientPIDRef,
        payerId: billData.messageHeader.recipientPid
      });

      user.firstName = senderName;
      this.dm.userSession.setState({ isLoading: false });
      return <LayoutComponent hideHeader={false} children={ <PaymentScreen isAllowPayment={true} payType={paytype} billData={billData} msgList={data.message.messages} cardDisplayList={[]} user={user} /> } />

    }
    else
      this.nav.to(await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_HOMESCREEN));
  }

  async declinedAction({ paytype }) {
    let { billDetails } = this.dm.billDetails.state;
    if (!!billDetails && !!billDetails.threadId) {
      this.dm.userSession.setState({ isLoading: true });
      let data = await this.dm.dashboard.getBill(billDetails.threadId);
      if (!data || !data.message) {
        this.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
        return false;
      }
      this.dm.userSession.setState({ isLoading: false });
      return <LayoutComponent hideHeader={false} children={ <DeclineComponent payType={paytype} billData={data.billDetail} /> } />
    }
    else 
      this.nav.to(await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_HOMESCREEN));
  }

  async extensionAction({ paytype }) {
    let { billDetails } = this.dm.billDetails.state;
    if (!!billDetails && !!billDetails.threadId) {
      this.dm.userSession.setState({ isLoading: true });
      let data = await this.dm.dashboard.getBill(billDetails.threadId);
      if (!data || !data.message) {
        this.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
        return false;
      }
      this.dm.userSession.setState({ isLoading: false });
      return <LayoutComponent hideHeader={false} children={ <ExtensionScreen payType={paytype} billData={data.billDetail} msgList={data.message.messages} leftMenuToggle={this.dm.userSession.state.leftMenuToggle} isMobileDevice={this.dm.notificationDomain.state.isMobileDevice} /> } />

    }
    else
      this.nav.to(await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_HOMESCREEN));
  }

  async billersDirectoryScreenAction() {
    return <LayoutComponent hideHeader={true} children={ <BillersDirectoryScreen />} />
  }
  async simpleMessageScreenAction() {
    return <LayoutComponent hideHeader={true} disableScroll={true} children={ <SimpleMessageScreen />} />
  }

  async deleteAccountAction() {
    return <LayoutComponent hideHeader={true} children={ <DeleteAccountScreen />} />

  }

  async simpleMessagesDetailsAction() {
    let threadId = "";
    let { currentThreadId } = this.dm.simpleMessage.state;
    if (!!currentThreadId) {
      threadId = currentThreadId
    }
    else {
      this.nav.back();
      return false;
    }
    this.dm.userSession.setState({isLoading : true});

    let messages = await this.dm.simpleMessage.getSimpleMessageByThreadId(threadId);
    if (!messages) {
      this.dm.userSession.setState({isLoading : false});
      this.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
      return false;
    } else {
      let { simpleMessage } = this.dm.simpleMessage.state;
      let dbData = simpleMessage.find(x => x.threadId === threadId);
      if (!dbData) this.nav.back();

      let linkPids = await this.dm.rest.getLinkedPID();
      const { threadHeader, messageHeader } = messages[0].envelope;
      let biller = null;
      if (linkPids.split(',').includes(threadHeader.originatorPid)) {
        biller = { payerId: messageHeader.senderPid, billerId: messageHeader.recipientPid, };
      }
      else {
        biller = { payerId: messageHeader.recipientPid, billerId: messageHeader.senderPid };
      }

      let billerDetails = await this.dm.rest.getBillers(biller);
      if (billerDetails && billerDetails.length) billerDetails = billerDetails[0];
      let userDetails = await this.dm.rest.getuserBUDetails(biller);
      if (userDetails && userDetails.length) userDetails = userDetails[0];
      this.dm.userSession.setState({isLoading : false});
      return <LayoutComponent hideHeader={false} disableScroll={true} children={<SimpleMessageDetailScreen messageDetails={messages} dbData={dbData} billerDetails={billerDetails} userDetails={userDetails} linkPids={linkPids} />} />
    }
  }

  async createMessageAction() {
    this.dm.userSession.setState({isLoading : true});
    let data = await this.dm.rest.getBillerBUs();
    const userLoginDetail = await this.dm.rest.getUser();
    let billNameList = data.billNameList.filter(x =>  x.payerId === userLoginDetail.pid);
    if (!!billNameList && billNameList.length > 0) {
      let { pamList } = this.dm.billerDirectoryDomain.state.pamList;
      if (!pamList || pamList.length === 0)
        await this.dm.billerDirectoryDomain.getPamMessages();

      pamList = this.dm.billerDirectoryDomain.state.pamList;
      billNameList = billNameList.filter(o1 => !!pamList.some(o2 => !!o2.biller && o1.value === o2.biller.uid && o2.status !== "denied" && o2.status !== "blocked" && o2.status !== "requested"));
    }
    this.dm.userSession.setState({isLoading : false});
    return <LayoutComponent hideHeader={false} children={ <CreatingMessageScreen billerNameList={billNameList} leftMenuToggle={this.dm.userSession.state.leftMenuToggle} isMobileDevice={this.dm.notificationDomain.state.isMobileDevice} /> } />
  }

  async billReceiptAction() {
    let { billDetails } = this.dm.billDetails.state;
    if (!!billDetails && !!billDetails.threadId) {
      return <LayoutComponent hideHeader={false} children={ <BillReceiptScreen billDetails={billDetails} /> } />
    }
    else {
      this.nav.back();
      return false;
    }
  }

  async paymentOptionsAction() {
    this.dm.userSession.setState({isLoading : true});
    let cardDisplayList = await this.dm.billDetails.getPayerCardDetailsList();
    let bankAccountList = await this.dm.billDetails.getPayerAccountDetailsList();
    let prevRoute = this.nav._r14.navigation._prevRoute != null ? this.nav._r14.navigation._prevRoute.name : null;
    if (!!prevRoute && prevRoute !== "addNewAccountRoute" && prevRoute !== "editAccountRoute") {
      this.dm.billDetails.setState({ bankTabActive: "Card" });
    }
    this.dm.userSession.setState({isLoading : false});
    return <LayoutComponent hideHeader={true} children={ <PaymentOptionsScreen cardDisplayList={cardDisplayList} bankAccountList={bankAccountList} /> } />
  }
  async notificationScreenAction() {
    const userLoginDetail = await this.dm.rest.getUser();
    await this.dm.notificationDomain.notificationDetail();
    return <LayoutComponent hideHeader={false} children={ <NotificationScreen userLoginDetail={userLoginDetail} /> } />
  }
  async billRequestScreenAction() {
    const userLoginDetail = await this.dm.rest.getUser();
    let industry = await this.dm.billRequest.getIndustries();
    return <LayoutComponent hideHeader={false} children={ <BillRequestScreen userLoginDetail={userLoginDetail} industries={industry} /> } />
  }

  async externalScannerAction(portal) {
    let threadId = "";
    if(Platform.OS === 'web') threadId = portal.portals.root.path;
    else threadId = portal.threadId;
    if(threadId) threadId = threadId.split("/").pop();
    return null;
  }

  async bankAccountAction() {
    const userLoginDetail = await this.dm.rest.getUser();
    let payerBankAccounts = await this.dm.achPaymentDomain.getPayerBankAccounts(
      {
        pId: { eq: userLoginDetail.pid },
        isActive: true
      });
    payerBankAccounts = !!payerBankAccounts ? payerBankAccounts.filter(account => account.isActive) : [];
    const sortedPayerBankAccounts = payerBankAccounts.sort((bankA, bankB) => bankB.bankName > bankA.bankName ? -1 : 1);
    return <LayoutComponent hideHeader={true} children={<MyBanksScreen profile={userLoginDetail} payerBankAccounts={sortedPayerBankAccounts} />} />;
  }

  async linkPayerAction() {
    return <LayoutComponent hideHeader={false} children={<LinkPayerScreen />} />;

  }

  async textToPayAction({ messageMetaIdentifier }) {
    return <LayoutComponent hideHeader={true} children={<TextToPayScreen messageMetaIdentifier={messageMetaIdentifier} />} />;
  }

  async pchPrivacyPolicy() {
    return <LayoutComponent hideHeader={true} isAuthenticated={false} children={<PCHPrivacyPolicy />} />;

  }

  async pchuserterms() {
    return <LayoutComponent hideHeader={true} isAuthenticated={false} children={<PCHUserTerms />} />;
  }

  async accessServicesAgreement() {
    return <LayoutComponent hideHeader={true} isAuthenticated={false} children={<AccessServicesAgreement />} />;
  }

  async termsAndconditionsAction() {
    return <LayoutComponent hideHeader={true} isAuthenticated={false} children={<TermsAndConditionsScreen />} />;
  }
  
  async checkoutPayment({ data }) {
    const userDetails = await this.dm.rest.getUserWithDetails();
    let payload = await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_BILLRECEIPTS);
    if (!!userDetails && !!payload) {
      payload = RSAencryption.decryptDataByATOB(payload);
      payload = JSON.parse(payload);
      if (!!payload && !!payload.transactiondetails) {
        let stripePayload = {
          ...payload,
          ...{
            billingaddress: {
              ...payload.billingaddress,
              user_address1: userDetails.addressLine1 || "",
              user_address2: userDetails.addressLine2 || "",
              user_zip: userDetails.postCode || "",
              user_city: (userDetails.cityObject && userDetails.cityObject.label ? userDetails.cityObject.label : userDetails.town || ""),
              user_state: (userDetails.stateObject && userDetails.stateObject.label ? userDetails.stateObject.label : userDetails.state || ""),
            }
          },
        };
        stripePayload.data = RSAencryption.decryptDataByATOB(data);
        return <LayoutComponent hideHeader={false} children={<CheckoutSessionComponent userDetails={userDetails} paymentPayload={stripePayload} />} />
      }
    }
    this.nav.to(await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_HOMESCREEN));
    return false;
  }

  async paymentReceipt() {
    this.dm.userSession.setState({isLoading : true});
    let payload = await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_BILLRECEIPTS);
    if (!!JSON.parse(payload) && !!JSON.parse(payload).session_id) {
      let response = await this.dm.dashboard.payBill(payload);
      if (!!response && response.billDetail && !!response.billDetail.threadId) {
        try {
          AsyncStorage.removeItem(CommonString.LOCAL_STORAGE_BILLRECEIPTS);
        } catch (error) {
          AsyncSessionStorage.removeItem(CommonString.LOCAL_STORAGE_BILLRECEIPTS);
        }
        let dbpayload = response.billDetail;
        const { compiledMsgList, filterBills } = this.dm.dashboard.state;
          if (!!compiledMsgList.length && !!filterBills.length) {
            let ind = compiledMsgList.findIndex((el) => el.uid === dbpayload.uid);
            compiledMsgList[ind].billStatus = dbpayload.billStatus;
            compiledMsgList[ind].amountDue = dbpayload.amountDue;
            compiledMsgList[ind].amountPaid = dbpayload.amountPaid;
            compiledMsgList[ind].bookmark = dbpayload.bookmark;
            compiledMsgList[ind].lastPaidAmount = dbpayload.lastPaidAmount;
            compiledMsgList[ind].paymentMode = dbpayload.paymentMode;
            compiledMsgList[ind].paymentStatus = dbpayload.paymentStatus;
            compiledMsgList[ind].rtpMessageType = dbpayload.rtpMessageType;
            compiledMsgList[ind].isFailedPayment = dbpayload.isFailedPayment;
            compiledMsgList[ind].paymentType = dbpayload.paymentType;
            let fndx = filterBills.findIndex((el) => el.uid === dbpayload.uid);
            filterBills[fndx].billStatus = dbpayload.billStatus;
            filterBills[fndx].amountDue = dbpayload.amountDue;
            filterBills[fndx].amountPaid = dbpayload.amountPaid;
            filterBills[fndx].bookmark = dbpayload.bookmark;
            filterBills[fndx].lastPaidAmount = dbpayload.lastPaidAmount;
            filterBills[fndx].paymentMode = dbpayload.paymentMode;
            filterBills[fndx].paymentStatus = dbpayload.paymentStatus;
            filterBills[fndx].rtpMessageType = dbpayload.rtpMessageType;
            filterBills[fndx].isFailedPayment = dbpayload.isFailedPayment;
            filterBills[fndx].paymentType = dbpayload.paymentType;

            await this.dm.dashboard.updateBillCount(compiledMsgList, filterBills);
          } 
        this.dm.billDetails.setState({ billDetails: dbpayload });
        this.dm.userSession.setState({isLoading : false});
        return <LayoutComponent hideHeader={false} children={<BillReceiptScreen billDetails={dbpayload} />} />
      }
    }
    this.dm.userSession.setState({isLoading : false});
    this.nav.to(await AsyncStorage.getItem(CommonString.LOCAL_STORAGE_HOMESCREEN));
    return false;
  }
}